import React, { useEffect, useState } from "react";
import '../Tablero.scss'
import listadoDeGuadias from '../../../../assets/icons/guardiasBlanco.png'
import { GetHora } from "../../../../CustomHooks/useGetHora";
import { getGuardias, transferenciaAOperadorGuardia } from "./integracionPanel";
import Button from "../../../../components/atoms/Button/Button";
import ModalTransferirGuardia from "../ModalTransferirGuardia";
import GlovalCard from "../../../../components/atoms/GlovalCard/GlovalCard";
import { extraerHora, formateoBasico, isoAUtc } from "../../../../utilities/formateos";
import InputLista from "../../../../components/atoms/InputLista/InputLista";
import Swal from "sweetalert2";
import { Tooltip } from "@mui/material";
import TextArea from "../../../../components/atoms/TextArea/TextArea";
import InputCalendario from "../../../../components/atoms/InputCalendario/InputCalendario";
import { getCausa, getEfectos, getIncidente } from "../../../../components/molecules/TablaBitacoras/TablaBitacorasntegracion";
import { jwtDecode } from "jwt-decode";

const ListadoDeGuardias = ({ rutas }) => {

    const [guardias, setGuardias] = useState()
    const [guardia, setGuardia] = useState(null)


    const [fecha, setFecha] = useState(formateoBasico(new Date()))
    const [causas, setCausas] = useState([])
    const [causa, setCausa] = useState(null)
    const [efectos, setEfectos] = useState([])
    const [efecto, setEfecto] = useState(null)
    const [afectoServicioCheck, setAfectoServicioCheck] = useState(false)
    const [responsabilidadSumaCheck, setResponsabilidadSumaCheck] = useState(true)
    const [facturaCheck, setFacturaCheck] = useState(false)
    const [detalle, setDetalle] = useState(null)
    const [notaFacturacion, setNotaFacturacion] = useState(null)
    const [incidenteData, setIncidenteData] = useState(null)
    const [tipoReembolso, setTipoReembolso] = useState("taxi")
    const [resIncidente, setResIncidente] = useState()


    // const [rutas, setRutas] = useState([])
    const [ruta, setRuta] = useState()

    useEffect(() => {
        getCausa(setCausas,'tablero')
      


    }, [])
    useEffect(() => {
        if(causa)
        {
            getEfectos(setEfectos,causa.code)
        }
    }, [causa])
    useEffect(() => {

        const interval = setInterval(async () => {
            const data = {
                fecha_inicio: GetHora(-1),
                fecha_fin: GetHora(1),
            }
            getGuardias(data, setGuardias)
        }, 10000); // 10000 milisegundos = 10 segundos
        return () => {
            clearInterval(interval);
        };

    }, []);
    // useEffect(() => {
    //     if (incidenteData) {
    //         setFecha(isoAUtc(incidenteData.fecha))
    //         setEfecto({ name: incidenteData.EFECTO_NOMBRE, code: incidenteData.ID_EFECTO })
    //         setCausa({ name: incidenteData.CAUSA_NOMBRE, code: incidenteData.ID_CAUSA })
    //         setAfectoServicioCheck(incidenteData.AFECTO_SERVICIO)
    //         setResponsabilidadSumaCheck(incidenteData.RESPONSABILIDAD_SUMA)
    //         setDetalle(incidenteData.DETALLE)
    //         setNotaFacturacion(incidenteData.NOTA_FACTURACION)

    //     }
    // }, incidenteData)
    const tramsferir = () => {

        if (ruta) {
            Swal.fire({
                title: '¿Estás seguro?',
                text: "Realmente desde atransferir",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#28a745', // Verde
                cancelButtonColor: '#d33',     // Rojo
                confirmButtonText: 'Sí',
                cancelButtonText: 'No'
            }).then((result) => {
                if (result.isConfirmed) {
                    // Acción si el usuario presiona "Sí"
                    setGuardia(null)
                    const dataIncidente = {
                        id_causa: causa?.code,
                        detalle: detalle,
                        id_efecto: efecto?.code,
                        facturar:facturaCheck?'1':'0',
                        fecha: fecha,
                        id_unidad: ruta?.unidad,
                        nota_facturacion: notaFacturacion,
                        responsabilidad_suma:causa.RESPONSABILIDAD_SUMA?'1':'0',
                        id_usuario: ruta?.chofer,
                        tipo: causa.TIPO,
                        afecto_servicio:causa.AFECTA_SERVICIO?'1':'0',//usuario quien hace la transferencia 
                        id_bitacora: ruta.id,
                        usuario_incidente: "modulo tablero / guardias Incidencia hecha por :" + jwtDecode(sessionStorage.getItem("token")).NOMBRE,
                        transferido_por:'Transferido por : '+jwtDecode(sessionStorage.getItem("token")).NOMBRE,
                        transferido_por_id:jwtDecode(sessionStorage.getItem("token")).ID,
                    }
                    transferenciaAOperadorGuardia(guardia.id, ruta.id, guardia.ID_CHOFER, ruta.name, setRuta, dataIncidente, setResIncidente,limpiarDatos)
                } else {
                    // Acción si el usuario presiona "No"
                }
            });
        }
        else {
            Swal.fire({
                icon: 'error',   // Icono de error
                text: 'Selecciona la ruta que desea cubrir', // Mensaje de error
                confirmButtonText: 'OK'  // Texto del botón de confirmación
            });
        }
    }
    const limpiarDatos = ()=>
    {
        setRuta(null)
        setCausa(null)
        setEfecto(null)
        setNotaFacturacion(null)
        setDetalle(null)
    }

    return (
        <div className="ListadoDeGuardias">
            <div className="titulo-panel">
                <img src={listadoDeGuadias} alt="" />
                <div>
                    <div className="titulo">Listado de guardias disponibles con cuadrante</div>
                    <div className="subtitulo">Personal listo para transferencias • {guardias?.length || 0} disponibles</div>
                </div>
            </div>
            
            <div className="guardias-container">
                {guardias?.length > 0 ? (
                    guardias.map((item, index) => (
                        <div key={index} className="guardia-conainer">
                            <div className="unidad">U-{item.ID_UNIDAD}</div>
                            <div className="guardia">
                                <div className="operador">
                                    <i className="pi pi-user" style={{ marginRight: '8px', color: '#87ceeb' }}></i>
                                    {item.OPERADOR}
                                </div>
                                <div className="estatus-cuadrante">
                                    <div>
                                        <div className="cuadrante">
                                            <i className="pi pi-map-marker" style={{ marginRight: '5px', color: '#87ceeb' }}></i>
                                            Ruta: {item.RUTA}
                                        </div>
                                        <div className="cuadrante">
                                            <i className="pi pi-clock" style={{ marginRight: '5px', color: '#87ceeb' }}></i>
                                            Turno: {item.TURNO[1]}
                                        </div>
                                        <div className="cuadrante">
                                            <i className="pi pi-phone" style={{ marginRight: '5px', color: '#87ceeb' }}></i>
                                            Teléfono: {item.TELEFONO}
                                        </div>
                                    </div>

                                    {item.RESCATA == 1 ? (
                                        <Tooltip title={item.RESCATADA}>
                                            <div className="recatando">
                                                <i className="pi pi-spin pi-spinner" style={{ marginRight: '5px' }}></i>
                                                Rescatando
                                            </div>
                                        </Tooltip>
                                    ) : (
                                        <Button width="160px" className="transfer-button" onClick={() => setGuardia(item)}>
                                            <i className="pi pi-arrow-right" style={{ marginRight: '5px' }}></i>
                                            Transferir
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="empty-guardias">
                        <div style={{ 
                            textAlign: 'center', 
                            padding: '40px 20px', 
                            color: 'rgba(255, 255, 255, 0.7)' 
                        }}>
                            <i className="pi pi-users" style={{ 
                                fontSize: '3rem', 
                                color: '#007ad9', 
                                marginBottom: '15px',
                                display: 'block'
                            }}></i>
                            <div style={{ fontSize: '1.1rem', fontWeight: '600', marginBottom: '8px' }}>
                                No hay guardias disponibles
                            </div>
                            <div style={{ fontSize: '0.9rem', opacity: '0.8' }}>
                                En este momento no hay personal de cuadrante disponible para transferencias
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {guardia && (
                <ModalTransferirGuardia>
                    <GlovalCard>
                        <div className="tituloModalContainer">
                            <div className="tituloModal">
                                <i className="pi pi-arrow-right-arrow-left" style={{ marginRight: '10px', color: '#007ad9' }}></i>
                                Transferir Servicio - {guardia.RUTA}
                            </div>
                            <div className="x" onClick={() => setGuardia(null)}>
                                <i className="pi pi-times"></i>
                            </div>
                        </div>
                        
                        <div className="bodyModal">
                            <div className="nombreContainer" style={{ 
                                background: 'rgba(0, 122, 217, 0.1)', 
                                padding: '15px', 
                                borderRadius: '8px',
                                border: '1px solid rgba(0, 122, 217, 0.3)',
                                marginBottom: '15px'
                            }}>
                                <div className="nombre">
                                    <i className="pi pi-file-o" style={{ marginRight: '8px', color: '#007ad9' }}></i>
                                    <span><b>Bitácora: </b></span>{guardia.id}
                                </div>
                                <div className="nombre" style={{ marginTop: '8px' }}>
                                    <i className="pi pi-user" style={{ marginRight: '8px', color: '#007ad9' }}></i>
                                    <span><b>Operador destino: </b></span>{guardia.OPERADOR}
                                </div>
                            </div>
                        </div>
                        
                        <div className="line"></div>
                        
                        <div className="bodyModal">
                            <div className="transferirOperador">
                                <div className="texto" style={{ 
                                    fontSize: '1rem', 
                                    fontWeight: '600', 
                                    color: '#2c3e50',
                                    marginBottom: '10px'
                                }}>
                                    <i className="pi pi-exchange" style={{ marginRight: '8px', color: '#007ad9' }}></i>
                                    Información del servicio
                                </div>
                                <div className="contenedorHoras">
                                    <div className="hora" style={{
                                        background: '#f8f9fa',
                                        padding: '10px',
                                        borderRadius: '6px',
                                        border: '1px solid #dee2e6'
                                    }}>
                                        <i className="pi pi-clock" style={{ marginRight: '5px', color: '#007ad9' }}></i>
                                        Hora inicio: <span><b>{extraerHora(guardia.INICIO)}</b></span>
                                    </div>
                                    <div className="hora" style={{
                                        background: '#f8f9fa',
                                        padding: '10px',
                                        borderRadius: '6px',
                                        border: '1px solid #dee2e6'
                                    }}>
                                        <i className="pi pi-flag" style={{ marginRight: '5px', color: '#007ad9' }}></i>
                                        Hora arribo: <span><b>{extraerHora(guardia.FIN)}</b></span>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="transferir">
                                <div className="margen">
                                    <div className="conainerFecha">
                                        <InputLista 
                                            options={rutas} 
                                            value={ruta} 
                                            onChange={(e) => setRuta(e.value)} 
                                            titulo="Seleccione la ruta que va a cubrir *"
                                        />
                                        <InputCalendario 
                                            className="inputCalendarioModal" 
                                            titulo="Fecha *" 
                                            value={fecha} 
                                            onChange={(e) => setFecha(e.target.value)}
                                        />
                                    </div>
                                    
                                    <div className="containerCEDN">
                                        <div className="cont">
                                            <InputLista 
                                                placeholder={causa?.name} 
                                                options={causas} 
                                                value={causa} 
                                                onChange={(e) => { setCausa(e.value); setEfecto(null) }} 
                                                titulo="Causa *"
                                            />
                                            <TextArea 
                                                onChange={(e) => setDetalle(e.target.value)} 
                                                value={detalle} 
                                                titulo="Detalle de la transferencia" 
                                                className="textAreaClass"
                                                placeholder="Describe el motivo de la transferencia..."
                                            />
                                        </div>
                                        <div className="cont">
                                            <InputLista 
                                                options={efectos} 
                                                value={efecto} 
                                                onChange={(e) => setEfecto(e.value)} 
                                                titulo="Efecto *"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div style={{ 
                                display: 'flex', 
                                gap: '10px', 
                                justifyContent: 'flex-end',
                                marginTop: '20px'
                            }}>
                                <Button 
                                    onClick={() => setGuardia(null)}
                                    style={{ 
                                        background: '#6c757d',
                                        borderColor: '#6c757d'
                                    }}
                                >
                                    <i className="pi pi-times" style={{ marginRight: '5px' }}></i>
                                    Cancelar
                                </Button>
                                <Button onClick={tramsferir}>
                                    <i className="pi pi-check" style={{ marginRight: '5px' }}></i>
                                    Confirmar transferencia
                                </Button>
                            </div>
                        </div>
                    </GlovalCard>
                </ModalTransferirGuardia>
            )}
        </div>
    )
}
export default ListadoDeGuardias